import { render, staticRenderFns } from "./UploadRede.vue?vue&type=template&id=6c2190b8"
import script from "./UploadRede.vue?vue&type=script&lang=js"
export * from "./UploadRede.vue?vue&type=script&lang=js"
import style0 from "./UploadRede.vue?vue&type=style&index=0&id=6c2190b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports